export default "__VITE_ASSET__49444b25__"